<template>
  <div class="modal fade" id="shipping-product-add-modal" role="dialog" @click="$emit('close')" :style="{ 'z-index': zIndex || 1050 }">
    <div class="modal-dialog modal-xl" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="panel products-table" ref="deliveryProductModal" style="position: relative">
            <table-shipping-product-add
              :url="apiUrl"
              :isShippingAmazon="true"
              :descriptions="descriptions"
              :extraUrl="['Product/get-image-name']"
              :extraUrlMode="true"
              :columns="columns"
              :isSearchable="true"
              :needExtraData="true"
              :loadingTableMode="true"
              :clientMode="true"
              :checkedItems="checkedItems"
              :isShowBtnBulkCreate="true"
              :selectedProducts="selectedProducts"
              ref="shippingProductAddTable"
              @countData="countData = $event"
              @extraData="extraData = $event"
              @keyword="onHandleSearch"
              @zIndex="zIndex = $event"
              @checkBoxAll="checkBoxAll"
              @bulkAdd="bulkAddProducts"
            >
              <template slot="checkBoxAll" slot-scope="props">
                <input type="checkbox" :value="props.rowData.itemId" v-model="checkedItems" @change="refreshCheckAll" :disabled="!props.rowData.scQuantity">
              </template>
              <template slot="status" slot-scope="props">
                <span class="box-delivery-judgment-status" :class="getJudgmentStatusClass(props.rowData.status_str)">{{ props.rowData.status_str }}</span>
              </template>
              <template slot="productName" slot-scope="props">
                <div class="flex" style="justify-content: left;">
                  <loading-block :value="props.rowData.image" type="image">
                    <img :src="prepareImgSrc(props.rowData.image)" class="product-img"/>
                  </loading-block>
                  <loading-block :value="props.rowData.itemName" type="string">
                    <a class="text--underline" :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin" target="_blank">
                      {{props.rowData.itemName}}
                    </a>
                    <div><b>ASIN：</b>{{props.rowData.asin}} / <b>SKU：</b>{{ props.rowData.sku }} </div>
                    <div><b>商品ID：</b>{{props.rowData.itemId}} / <b>商品ラベル：</b>{{ props.rowData.goodsLabel }}</div>
                  </loading-block>
                </div>
              </template>
              <template slot="amazonQuantity" slot-scope="props">
                <span class="text-size-20">{{ formatNumber(props.rowData.amazonQuantity) }}</span> 個
              </template>
              <template slot="scQuantity" slot-scope="props">
                <span class="text-size-20">{{ formatNumber(props.rowData.scQuantity) }}</span> 個
              </template>
              <template slot="action" slot-scope="props">
                <button class="btn btn-warning" @click="addProduct(props.rowData)" :disabled="!props.rowData.scQuantity">追加</button>
              </template>
            </table-shipping-product-add>
            <div class="row m-b-sm">
              <div class="flexbox justify-right">
                <button v-if="checkedItems.length" type="button" class="btn btn-warning btn-add-checked-all mr-r-10" @click="bulkAddProducts()">選択した商品を追加</button>
                <div data-dismiss="modal" @click="$emit('close')">
                  <button class="btn ver-middle w-120">閉じる</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from '@/common/utility'
import TableShippingProductAdd from '@/view/warehouseSc/components/TableShippingProductAdd'
import LoadingBlock from '@/components/LoadingBlock'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    selectedProducts: {
      type: Array,
      default () {
        return []
      }
    },
    iconUrls: {
      type: Object,
      default () {
        return {
          'Amazon': '',
          'salmonSc': ''
        }
      }
    }
  },
  components: {
    TableShippingProductAdd,
    LoadingBlock
  },
  data () {
    return {
      apiUrl: '/Warehouse/sc/shipping/amazon/product-available',
      error: null,
      loader: null,
      zIndex: null,
      countData: null,
      extraData: null,
      keyword: null,
      columns: [
        {
          title: '<input type="checkbox" id="checkbox-all">',
          name: 'checkBoxAll',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-30 th-checkbox-all',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'ステータス',
          name: 'status',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-100',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '商品情報',
          name: 'productName',
          cellClass: 'text-left',
          customCell: true,
          headerClass: 'product-name',
          sortable: false,
          textAlign: 'left',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'Amazon在庫数',
          name: 'amazonQuantity',
          cellClass: 'text-right',
          customCell: true,
          headerClass: 'w-150',
          sortable: false,
          textAlign: 'right',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'STOCKCREW在庫数',
          name: 'scQuantity',
          cellClass: 'text-right',
          customCell: true,
          headerClass: 'w-150',
          sortable: false,
          textAlign: 'right',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '',
          name: 'action',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-75',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        }
      ],
      checkedItems: []
    }
  },
  computed: {
    descriptions () {
      return `
        <img src="${this.iconUrls['salmonSc']}" class="w-20" alt="">STOCKCREW倉庫
        →
        <img src="${this.iconUrls['Amazon']}" class="w-20" alt="">Amazon倉庫 へ納品する商品を選択してください
      `
    }
  },
  created () {
    this.loader = this.$loading.show()
  },
  mounted () {
    this.$events.listen('done', (success) => {
      success && $('#shipping-product-add-modal').modal('show')
      this.loader && this.loader.hide()
    })
  },
  methods: {
    formatNumber (number) {
      if (number === null) {
        return '-'
      }
      return Util.formatMoney(number)
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    addProduct (product) {
      this.$emit('handleSelectedProduct', product)
      this.$refs.shippingProductAddTable.handleData(product, 'delete')
      this.checkedItems = this.checkedItems.filter(itemId => itemId !== product.itemId)

      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_add_product_btn,
        properties: {
          asin: product.asin
        }
      }
      EventService.postTrackLog(logParams)
    },
    bulkAddProducts () {
      let selectedProducts = []
      this.$refs.shippingProductAddTable.pageData.filter((product) => {
        if (this.checkedItems.includes(product.itemId)) {
          selectedProducts.push(product)
        }
      })

      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_add_products_btn,
        properties: {
          asins: this.checkedItems
        }
      }
      EventService.postTrackLog(logParams)

      this.$refs.shippingProductAddTable.handleData(this.checkedItems, 'deleteAll')
      this.checkAll = false
      this.checkedItems = []
      this.$emit('handleSelectedProducts', selectedProducts)
      this.$emit('close')
    },
    onHandleSearch (keywordValue) {
      this.keyword = keywordValue
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_search_btn,
        properties: {
          keyword: keywordValue
        }
      }
      EventService.postTrackLog(logParams)
    },
    refreshCheckAll () {
      const items = this.$refs.shippingProductAddTable.pageData
      if (this.checkedItems.length === items.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    checkBoxAll (value) {
      const items = this.$refs.shippingProductAddTable.pageData
      this.checkAll = value
      this.checkedItems = []
      var _self = this
      if (this.checkAll) {
        items.forEach(function (item) {
          if (!item.scQuantity) {
            // continue
          } else {
            _self.checkedItems.push(item.itemId)
          }
        })
      }
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
#shipping-product-add-modal /deep/ .box-base-table-search {
  display: block;
  justify-content: unset;
  align-items: unset;
  flex-wrap: unset;
}
#shipping-product-add-modal /deep/ .box-base-table-search .search-multiple {
  flex-grow: unset;
  margin-right: unset;
  display: flex;
  align-items: center;
}
#shipping-product-add-modal /deep/ .box-base-table-search .search-multiple input {
  margin-right: 30px;
}
#shipping-product-add-modal /deep/ .th-checkbox-all {
  padding: 6px;
  position: relative;
}
#shipping-product-add-modal /deep/ .th-checkbox-all input {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
}
#shipping-product-add-modal /deep/ .row {
  margin-right: 0px;
  margin-left: 0px;
}
.product-img {
  width: 75px;
}
@media (max-width: 1200px) {
  #shipping-product-add-modal /deep/ .table-wrapper {
    overflow-x: auto;
  }
  #shipping-product-add-modal /deep/ .table-wrapper .table {
    width: max-content;
    max-width: max-content;
  }
  #shipping-product-add-modal /deep/ .product-name {
    width: 500px;
  }
  #shipping-product-add-modal /deep/ .box-base-table-search .sale-detail-search {
    display: block;
    justify-content: unset;
  }
  #shipping-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block {
    display: flex;
    margin-bottom: 10px;
    margin-right: 0;
  }
  #shipping-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block label {
    width: 68px;
    margin-right: 0;
  }
  #shipping-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block input[name="detail"] {
    width: 184px;
  }
  #shipping-product-add-modal /deep/ .box-base-table-search .sale-detail-search .search-block select[name="mallCode"] {
    width: 184px;
  }
  #shipping-product-add-modal /deep/ .box-base-table-search .sale-detail-search .box-detail-btn-search {
    margin-left: 68px;
  }
}
@media (min-width: 1200px) {
  #shipping-product-add-modal /deep/ .box-base-table-search .sale-detail-search {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/components/ShippingAmazonProductAdd.vue